import './forms';
import './main-menu';
import './in-page-navigation';
import './search-block';
import './header';
import './accordion';
import './fund-detail';
import './button-scroll-top';
import './see-more';
import './external-link';
import './tables';
